<template>
  <div class="application-personal-form-container">
    <!-- TODO refactor -->
    <div class="col-md-12 m-b">
      <div class="b-light">
        <div class="container">
          <ul class="m-t-md h5 breadcrumb no-border bg-empty m-b-none m-l-n-sm">
            <li>
              <a href="#">การขาย</a>
            </li>
            <li class="active">
              <span class="text-success h4">ใบคำขอใหม่</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="content" style="padding-top: 20px; padding-bottom: 40px">
      <div class="col-md-12 mr-bt-table-bf">
        <HealthQuestionForm />
        <InsuredAddressForm />
        <InsurancePlanForm2 :typeInsurance="typeInsurance" />
        <FormBenefitInser />
        <ForeignerForm v-if="isForeigner" />
        <FormPayment
          :typeInsurance="typeInsurance"
          :isFirstApplicationPerson="isFirstApplicationPerson"
        />
        <FormRenew />
        <FormTax />

        <div class="application-submit-btn-container clearfix">
          <router-link :to="`/insurance_family/${familyId}`">
            <Button
              class="btn btn-dark btn-print pull-left m-r-xs"
              theme="outline"
              v-if="typeInsurance === 'family'"
            >
              กลับไปหน้าจัดการสมาชิก
            </Button>
          </router-link>

          <div class="pull-right" v-if="!isDisabledApplicationForm">
            <div class="save-draft-btn-container">
              <Button class="save-draft-btn" type="info" @click.native="saveDraft">
                บันทึกฉบับร่าง
              </Button>
            </div>

            <div class="submit-application-information-form-btn">
              <Button @click.native="submitApplicaionInformation">
                ส่งใบคำขอ/ยืนยันการทำประกันภัย
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import { Validator } from 'vee-validate'
import _ from 'lodash'
import moment from 'moment'

import Button from '@/components/Button'
import FormPayment from '@/components/Form/FormPayment.vue'
import HealthQuestionForm from '@/components/Form/HealthQuestionForm.vue'
import InsuredAddressForm from '@/components/Form/InsuredAddressForm.vue'
import FormBenefitInser from '@/components/Form/FormBenefitInser.vue'
import InsurancePlanForm from '@/components/Form/InsurancePlanForm.vue' // TODO remove it
import InsurancePlanForm2 from '@/components/Form/InsurancePlanForm2.vue'
import ForeignerForm from '@/components/Form/ForeignerForm.vue'
import FormRenew from '@/components/Form/FormRenew.vue'
import FormTax from '@/components/Form/FormTax.vue'
import InsuredAddressForm2 from '@/components/Form/InsuredAddressForm2.vue'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'ApplicationPersonal',
  validator: null,
  props: ['typeInsurance'],
  data: () => ({
    applicationId: null,
  }),
  mounted() {
    this.applicationId = this.$route.params.application_id

    this.getProvinceInformation()
    this.getBeneficiaryRelationship()
    this.getApplicationInformation(this.applicationId)
  },
  watch: {
    'applicationInformation.insuredAddress.insuredInformation': {
      handler: function () {
        const { insuredAddress, insuranceInformation } = this.applicationInformation

        const insuredAge = _.get(insuredAddress, 'insuredInformation.age', 0)
        const coverageCodes = _.get(insuranceInformation, 'coverageCode', null)

        if (insuredAge) {
          this.getInsurancePlanInformation({ coverageCodes, age: insuredAge })
        }
      },
      deep: true,
    },
    applicationData: {
      handler() {
        const familyId = _.get(this.applicationData, 'familyQuotation.familyId', null)
        const paymentId = _.get(this.applicationData, 'payment.id', null)

        if (this.typeInsurance !== 'family' && familyId) {
          this.$router.push(`/application_family/${this.applicationId}`)
        }

        if (this.typeInsurance === 'family' && !familyId) {
          this.$router.push(`/insurance_personal/${this.applicationId}`)
        }

        if (familyId) {
          this.getFamilyPayerInformation(familyId)
        }

        if (this.isForeigner) {
          this.getCountryInformation()
        }

        if (paymentId === 2) {
          this.getPaymentInformation(this.applicationId)
        }
      },
      deep: true,
    },
    paymentInformation(data) {
      if (data) {
        const accountNumber = _.get(data, 'detail.accountNumber', null)
        const accountName = _.get(data, 'detail.accountName', null)
        const accountProductCode = _.get(data, 'detail.accountProductCode', null)

        this.tmbMethodInformation.accountNumber = accountNumber.substring(4)
        this.tmbMethodInformation.accountName = accountName
        this.tmbMethodInformation.productCode = accountProductCode
      }
    },
    applicationValidationRules: {
      handler() {
        this.setRule()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'applicationInformation',
      'applicationValidationRules',
      'isDisabledApplicationForm',
    ]),
    ...mapApplicationFields({
      applicationData: 'data.applicationInformation',
      applicationValidationErrors: 'validation.errors',
      tmbMethodInformation: 'data.paymentMethod.tmbMethodInformation',
    }),
    ...mapPaymentFields({
      paymentInformation: 'paymentInformation.data',
    }),
    isFirstApplicationPerson() {
      const quotationId = _.get(this.applicationData, 'quotationId', null)
      const firstFamilyQuotationId = _.get(
        this.applicationData,
        'familyQuotation.quotations[0].quotationId',
        null,
      )

      return _.isEqual(quotationId, firstFamilyQuotationId)
    },
    familyId() {
      return _.get(this.applicationData, 'familyQuotation.familyId', null)
    },
    isForeigner() {
      return _.get(this.applicationData, 'insuredPerson.identityTypeId', 1) === 2
    },
  },
  components: {
    Button,
    FormPayment,
    HealthQuestionForm,
    InsuredAddressForm: InsuredAddressForm2,
    FormBenefitInser,
    InsurancePlanForm,
    ForeignerForm,
    FormRenew,
    FormTax,
    InsurancePlanForm2,
  },
  methods: {
    ...mapActions([
      'getApplicationInformation',
      'updateApplicationInformation',
      'getFamilyRelationship',
      'getBeneficiaryRelationship',
      'getInsurancePlanInformation',
      'getProvinceInformation',
      'getFamilyPayerInformation',
      'getCountryInformation',
      'getPaymentInformation',
    ]),
    prepareRequestData() {
      const {
        healthQuestion,
        insuredAddress,
        insurancePlanStartDate,
        beneficiary,
        foreigner,
        paymentMethod,
        isAutoRenewPolicy,
        reclaimTax,
      } = this.applicationInformation

      const { policySendMethod, insuredInformation, currentAddress, deliveryAddress } =
        insuredAddress

      const healthAnswers = _.chain(healthQuestion.question)
        .values()
        .reduce((acc, data) => (data ? `${acc},${data}` : acc))
        .value()

      return {
        application: {
          healthAnswers: healthAnswers || '',
          deliveryMethod: policySendMethod,
          policyStartDate: moment(insurancePlanStartDate).format('YYYY-MM-DD'),
          beneficiaryPersonRelationship1: beneficiary.firstPerson.relationship,
          beneficiaryPersonPercentage1: beneficiary.firstPerson.percentage,
          beneficiaryPersonRelationship2: beneficiary.secondPerson.relationship,
          beneficiaryPersonPercentage2: beneficiary.secondPerson.percentage,
          foreignerHasThailandResidency: foreigner.isHasThailandResidency,
          foreignerCountryResidency: foreigner.countryOfResidency,
          payerRelationshipId: paymentMethod.payerInformation.relationship,
          payerIdentityNumber: paymentMethod.payerInformation.payerId,
          payerMobileTel: paymentMethod.payerInformation.mobileTel,
          paymentId: paymentMethod.method,
          isAutoRenew: isAutoRenewPolicy,
          isAllowTaxExemption: reclaimTax.isReclaim,
          taxExemptionId: reclaimTax.taxPayerNumber,
        },
        insuredPerson: {
          insuredPersonId: insuredInformation.id,
          isOldGeneraliClient: false,
          mainAddress: currentAddress.address,
          mainSoiRoad: currentAddress.road,
          mainTambon: currentAddress.subdistrict,
          mainAmphoe: currentAddress.district,
          mainProvince: currentAddress.province,
          mainHomeTel: currentAddress.homePhone,
          mainMobileTel: currentAddress.mobilePhone,
          deliveryAddress: deliveryAddress.address,
          deliverySoiRoad: deliveryAddress.road,
          deliveryTambon: deliveryAddress.subdistrict,
          deliveryAmphoe: deliveryAddress.district,
          deliveryProvince: deliveryAddress.province,
          deliveryHomeTel: deliveryAddress.homePhone,
          deliveryMobileTel: deliveryAddress.mobilePhone,
        },
      }
    },
    saveDraft() {
      const data = this.prepareRequestData()

      this.updateApplicationInformation({ data, submitType: 'draft' })
    },
    submitApplicaionInformation() {
      const {
        healthQuestion: {
          isValidated: isHealthQuestionValidated,
          isPassValidate: isHealthQuestionPassValidate,
          question,
        },
        insuredAddress,
        insurancePlanStartDate,
        beneficiary,
        foreigner,
        paymentMethod,
        isAutoRenewPolicy,
        reclaimTax,
      } = this.applicationInformation

      const { policySendMethod, currentAddress, deliveryAddress } = insuredAddress

      this.validator
        .validateAll({
          q1: question.q1,
          q2: question.q2,
          q3: question.q3,
          q4: question.q4,
          q5: question.q5,
          deliveryMethod: policySendMethod,
          currentAddress: currentAddress.address,
          currentRoad: '',
          currentSubdistrict: currentAddress.subdistrict,
          currentDistrict: currentAddress.district,
          currentProvince: currentAddress.province,
          currentCountry: currentAddress.country,
          currentPostalCode: currentAddress.postalCode,
          currentMobilePhone: currentAddress.mobilePhone,
          deliveryAddress: deliveryAddress.address,
          deliveryRoad: '',
          deliverySubdistrict: deliveryAddress.subdistrict,
          deliveryDistrict: deliveryAddress.district,
          deliveryProvince: deliveryAddress.province,
          deliveryCountry: deliveryAddress.country,
          deliveryPostalCode: deliveryAddress.postalCode,
          deliveryMobilePhone: deliveryAddress.mobilePhone,
          effectiveDate: insurancePlanStartDate,
          payerRelationship: paymentMethod.payerInformation.relationship,
          beneficiaryFirstPersonRelationship: beneficiary.firstPerson.relationship,
          beneficiaryFirstPersonPercentage: beneficiary.firstPerson.percentage,
          beneficiarySecondPersonRelationship: beneficiary.secondPerson.relationship,
          beneficiarySecondPersonPercentage: beneficiary.secondPerson.percentage,
          isHasThailandResidency: foreigner.isHasThailandResidency,
          countryOfResidency: foreigner.countryOfResidency,
          paymentMethod: paymentMethod.method,
          isAutoRenewPolicy,
          isReclaimTax: reclaimTax.isReclaim,
        })
        .then((isValidationPass) => {
          if (isValidationPass && isHealthQuestionValidated && isHealthQuestionPassValidate) {
            const data = this.prepareRequestData()
            this.updateApplicationInformation({ data, submitType: 'submit' })
          } else {
            this.$swal({
              type: 'error',
              title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            })
          }
        })
    },
    setRule() {
      this.validator = new Validator(this.applicationValidationRules)
      this.$set(this, 'applicationValidationErrors', this.validator.errors)
    },
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss">
.application-submit-btn-container {
  .save-draft-btn-container,
  .submit-application-information-form-btn {
    display: inline-block;
  }

  .submit-application-information-form-btn {
    margin-left: 12px;
  }
}
</style>
